"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _numeral = _interopRequireDefault(require("numeral"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    statisticValue: function statisticValue(_ref2) {
      var cursor = _ref2.cursor;
      return {
        display: 'inline-block',
        fontFamily: 'Lato',
        fontSize: '1.5rem',
        lineHeight: 1.33,
        color: palette.text.primary,
        cursor
      };
    },
    statisticDesc: {
      fontSize: '1rem',
      lineHeight: 1.5,
      color: palette.text.primary
    }
  };
});

var GiftStatisticWrapper = function GiftStatisticWrapper(_ref3) {
  var title = _ref3.title,
      value = _ref3.value;
  var cursor = value < 1000 ? 'default' : 'help';
  var classes = useStyles({
    cursor
  });
  var formattedValue = (0, _react.useMemo)(function () {
    if (value < 1000) {
      return /*#__PURE__*/_react.default.createElement("span", null, value);
    }

    var formatted = (0, _numeral.default)(value).format('0.0a');
    return /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
      title: value,
      "aria-label": "Amount"
    }, /*#__PURE__*/_react.default.createElement("span", null, formatted));
  }, [value]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.statisticValue
  }, formattedValue), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.statisticDesc, 'Body-Regular-Left-Static')
  }, " ", title));
};

GiftStatisticWrapper.propTypes = {
  title: _propTypes.default.string.isRequired,
  value: _propTypes.default.number.isRequired
};
var _default = GiftStatisticWrapper;
exports.default = _default;